<template>
  <div>
    <div v-if="loading">
      <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>Carregando ..
    </div>
    <table class="striped edit-table">
      <thead>
        <tr>
          <th>Ordem</th>
          <th>Categoria</th>
          <th>Itens Qtde</th>
          <th>Itens Editar</th>
          <th style="width: 30px"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <input
              type="text"
              v-model="item.ordem"
              v-on:change="change_value"
              class="form-control"
              v-bind:id="getIDItem('ordem', index)"
            />
          </td>
          <td>{{item.categoria_nome}}</td>
          <td>{{item.itens_qtde.length > 0 ? item.itens_qtde[0].qtde : 0 }}</td>
          <td>
            <md-button
              class="md-just-icon md-primary md-simple"
              @click="abrir_modal_itens(item, index)"
            >
              <md-icon>playlist_add_check</md-icon>
            </md-button>
          </td>

          <td>
            <md-button class="md-just-icon md-info md-simple" @click.native="excluir(item, index)">
              <md-icon>remove_circle</md-icon>
            </md-button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal v-if="show_modal" @close="closeModal()" :force_height="1">
      <div slot="body">
        <comp_modelo_checklist_itens_cad v-model="items" :index="index_categoria"></comp_modelo_checklist_itens_cad>
      </div>
    </modal>
  </div>
</template>

<script>
import service from "../../../services/ModeloChecklistItensService";
import modal from "../../../components/Modal";
import comp_modelo_checklist_itens_cad from "./comp_modelo_checklist_itens_cad";

export default {
  props: ["tabela", "id_pai", "onSave", "onPreSave", "p_items"],
  model: {
    prop: "p_items",
    event: "change"
  },
  components: {
    modal,
    comp_modelo_checklist_itens_cad
  },
  watch: {
    p_items(val) {
      this.items = this.p_items;
    }
  },
  data: function() {
    return {
      items: [],

      ids_excluir: [],

      action: "list",
      id: "",
      table: null,
      filtro_titulo: "",
      filtro_status: "",

      show_new_button: true,
      show_modal: false,

      item_categoria: null,
      index_categoria: -1,

      loading: false,
      msg_status: "Carregando",
      disableButton: false,

      message_text: "",
      show_message: "off",

      button_new_text: "" //<i class=\"fa fa-file\" ></i> NOVA POST"
    };
  },
  methods: {
    closeModal() {
      this.show_modal = false;
      if (this.item_categoria != undefined) {
        this.items[this.index_categoria] = this.item_categoria;
      }
    },

    abrir_modal_itens(item, index) {
      //this.item_categoria = JSON.parse(  JSON.stringify(  this.items[index] ) );

      this.item_categoria = this.items[index];
      this.index_categoria = index; // index;
      this.show_modal = true;
    },

    isScrolledIntoView(
      elem //Isso aqui vai permitir testar o scrolling.
    ) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },

    getIDItem(nome, index) {
      return "chklist_" + nome + "_L" + index.toString();
    },
    change_data_item(id_campo, value) {
      if (id_campo.indexOf("data") > -1) {
        var ar = id_campo.split("_L");
        var index = ar[1];
        var item = this.items[parseInt(index)];

        var arcampo = id_campo.split("chklist_");
        var arcampo2 = arcampo[1].split("_L");
        var nome_campo = arcampo2[0];

        // console.log("Localizado nome do campo " + nome_campo + " e data"+ value);

        item[nome_campo] = value;
        Vue.set(this.items, parseInt(index), item);
        //console.log("Consegui alterar para o indice : " + index );
      }
    },
    change_value(event) {
      if (event != undefined && event.target != undefined) {
        this.change_data_item(event.target.id, event.target.value);
      }

      //this.$emit("change", items);
    },
    excluir(item, index) {
      // console.log("Excluir? ");

      if (item.id != null && item.id != "") {
        this.ids_excluir.unshift(item.id);
      }

      this.items.splice(index, 1);
      this.$emit("change", this.items);
      this.$emit("update:ids_excluir", this.ids_excluir);
    },

    salvar() {
      var self = this;
      var hd_json = JSON.stringify(this.items);
      var ids_delete_json = JSON.stringify(this.ids_excluir);

      if (this.onPreSave != null && this.onPreSave != undefined) {
        this.onPreSave(this.tabela, this.id_pai);
      }

      self.disableButton = true;
      self.loading = true;
      self.msg_status = "Salvando";

      service
        .salvarGrid(hd_json, ids_delete_json, this.tabela, this.id_pai)
        .then(function(response) {
          self.disableButton = false;
          self.loading = false;
          self.msg_status = "Carregando";
          self.show_message = "on";
          self.message_text = "Categorias salvas com sucesso!";

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(self.tabela, self.id_pai, self.items);
          }
        })
        .catch(function(error) {
          console.log(JSON.parse(JSON.stringify(error)));
        });
    },
    add() {
      this.items.push(this.getArrayItem());
    },
    loadData() {
      var self = this;

      var url = "contatos_gridcad"; //
      this.disableButton = true;
      this.loading = true;
      this.msg_status = "Carregando";

      var data = {};

      //console.log("Montei?  " + this.id_pai );
      if (
        this.id_pai != null &&
        this.id_pai != undefined &&
        this.id_pai != ""
      ) {
        service
          .getListByParent("categoria", this.id_pai)
          .then(function(response) {
            // console.log("Estou abrindo?? ");

            self.items = response.data.data;
            self.disableButton = false;
            self.loading = false;
            self.msg_status = "Carregando";

            self.$emit("change", self.items);
          })
          .catch(function(error) {
            console.log(JSON.parse(JSON.stringify(error)));
          });
      } else {
        self.disableButton = false;
        self.loading = false;
        self.msg_status = "Carregando";
      }
    },
    getArrayItem() {
      var data = service.getModel();

      if (this.id_pai != null) {
        data["id_modelo_check"] = this.id_pai;
      }

      return data;
    }
  },
  mounted() {
    let self = this;

    if (this.id_pai == null) {
      return;
    }

    this.loadData();
  }
};
</script>